export const AboutMeImage = () => (
	<div className={'image'}>
		<div className={'star-path-1'} />
		<div className={'star-path-2'} />
		<div className={'star-path-3'} />
	</div>
)
